import { render } from "./BreadcrumbItem.vue?vue&type=template&id=79886ae5"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"
script.render = render

export default script